<template>
    <div class="product-item animate__animated" :class="anmiateClass">
        <span class="img"></span>
        <b>{{ title }}</b> 
        <em v-dompurify-html="des"></em> 
    </div>
</template>
<script> 
    export default {
        name: "product-item",
        components: { 
        },
        props: { 
            title: {
                type: String,
                default: ''
            },
            img:{
                type: String,
                default: ''  
            },
            des:{
                type: String,
                default: ''  
            },
            anmiateClass:{
                type: String,
                default: ''  
            }
        },
        data() {
            return {  
            }
        },
        computed: { 
        },
        created() {   
        },
        methods: { 
        }
    }
</script>
<style lang="scss" scoped> 
$basePath: "~@/assets/images/icon/index/";
@mixin setBgImg($imgName) {
    background: url($basePath +$imgName) no-repeat center / cover;
}
.product-item{
    position: relative;
    margin:0 27px;
    width:427px;
    height: 455px; 
    padding:65px 62px;
    text-align: center;
    transition:0.5s;
    box-shadow: 0px 20px 20px -20px #626C79;
    overflow: hidden;
    &:hover{
        transform: translateY(-8px);
    }
    cursor: pointer; 
    b{
        display: block;
        font-size: 32px;
        height: 32px;
        color:#3750AB;
        line-height: 32px;
        margin-bottom: 47px;
    }
    em{
        font-size:14px;
        line-height: 24px;
        color:#666;
    } 
    .img{
        position: relative; 
        display: block;
        width:107px;
        height: 100px; 
        margin: 0 auto 60px;
    }
    @for $i from 1 through 6{
        &:nth-child(#{$i}){
            .img{
                @include setBgImg("icon-#{$i}.png");
                background-size:94px 94px;
            }
        }
    }
    &:nth-child(2){ 
        .img{ 
            background-size:92px 86px;
        }
    }
    &:nth-child(3){
        .img{ 
            background-size:100px 100px;
        }
    }
    &:nth-child(4){
        .img{ 
            background-size:107px 86px;
        }
    }
    &:nth-child(5){
        .img{ 
            background-size:84px 64px;
        }
    }
    &:nth-child(6){
        .img{ 
            background-size:96px 88px;
        }
    }
    
}
@media only screen and (max-width: 750px) { 

}
</style>